import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss']
})
export class ShopComponent implements OnInit {
  products: any[] = [];
  loading: boolean = false;
  parseAvailableSizes(value: string | null | undefined): string[] {
    if (!value) return [];
    return String(value)
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }

  constructor(
    private api: SharedService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadProducts();
  }

  async loadProducts(): Promise<void> {
    try {
      this.loading = true;
      const res: any = await this.api.getList(API_MODULES.PRODUCT);
      if (res?.status === 'success' && res?.data) {
        this.products = res.data;
      }
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      this.loading = false;
    }
  }

  getImg(path: string): string {
    if (!path) {
      return 'assets/no-image.png';
    }
    // If path already starts with http/https, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    // Otherwise, append to base URL
    return this.api.imageBase + path;
  }

  viewProduct(slugs: string): void {
    this.router.navigate(['/products-details', slugs]);
  }
}
